import { BASE_URL } from "./config";

export const fetchWithAuth = async (url, options = {}) => {
    const token = localStorage.getItem("token");

    const headers = {
        "Content-Type": "application/json",
        ...options.headers,
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
    };

    const fullUrl = `${BASE_URL}${url}`;

    const config = {
        ...options,
        headers,
    };

    const response = await fetch(fullUrl, config);

    const contentType = response.headers.get("content-type");
    const responseData = contentType && contentType.includes("application/json")
        ? await response.json().catch(() => ({}))
        : await response.text().catch(() => ({}));

    if (!response.ok) {
        const message =
            typeof responseData === "string"
                ? responseData
                : responseData.message || response.statusText || "Network error";
        throw new Error(message);
    }

    return responseData;
};
